module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s0-54a5e70d07cbb2c1030f9922cd95e8f1.svg";